import styled from 'styled-components';
import tw from 'twin.macro';
import { Meta } from '../../styled components/Typography';
import Button from '../Button/Button';
import UICard from '../../styled components/UICard';
import SVGIcon from '../SVGIcon/SVGIcon';

export const SettingsCategoryList = styled.ul(() => [tw`mb-0 space-y-8`]);

export const SettingListItem = styled.li(() => []);

export const SettingName = styled(Meta).attrs(() => ({
  $color: 'gray dark',
  as: 'p'
}))(() => []);

export const SettingInfoText = styled(Meta).attrs(() => ({
  $color: 'black',
  as: 'p'
}))(() => []);

export const SettingIcon = styled(SVGIcon)(() => [tw`mr-4 text-black text-opacity-60`]);

export const SettingLogoutButton = styled(Button)`
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
`;

export const SettingCard = styled(UICard).attrs(() => ({
  $padding: 16
}))(() => [tw`mb-16`]);
